// extracted by mini-css-extract-plugin
export default {"heading":"nT","container":"oT","product_section_row":"pT","carousel":"qT","carouselwide":"rT","carouselwrapper":"sT","blockwrapper":"tT","product_carousel_row":"uT","headingnarrow":"vT","title":"wT"};
    if(module.hot) {
      // 1726593107150
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  